import { React } from "react";

const Magnify = ({color}) => {
    return (
        <svg width="36" height="36" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_53_110)">
<path fillRule="evenodd" clipRule="evenodd" d="M33.6061 28.1502L41 35.5442L36.5467 40L29.1528 32.6061C26.2505 34.6331 22.7237 35.8308 18.9154 35.8308C9.02097 35.8308 1 27.8098 1 17.9154C1 8.02097 9.02357 0 18.9154 0C28.8073 0 36.8308 8.02097 36.8308 17.9154C36.8308 21.7237 35.6331 25.248 33.6061 28.1502ZM6.11613 17.918C6.11613 24.9869 11.8465 30.7147 18.9129 30.7147C25.9843 30.7147 31.7122 24.9869 31.7096 17.918C31.7096 10.8491 25.9818 5.12127 18.9129 5.12127C11.8465 5.12127 6.11613 10.8491 6.11613 17.918ZM16 20.4748H11.2348V15.3561H16V10.3846H21.3846V15.3561H26.5909V20.4748H21.3846V25.7692H16V20.4748Z" fill="url(#paint0_linear_53_110)"/>
</g>
<defs>
<filter id="filter0_d_53_110" x="0" y="0" width="42" height="43" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_110"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_110" result="shape"/>
</filter>
<linearGradient id="paint0_linear_53_110" x1="21" y1="14.3333" x2="21" y2="34.3333" gradientUnits="userSpaceOnUse">
<stop stopColor={color}/>
<stop offset="0.26124" stopColor={color}/>
<stop offset="0.346248" stopColor={color}/>
<stop offset="1" stopColor={color}/>
</linearGradient>
</defs>
</svg>

    )
}

export default Magnify